var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-card',{staticClass:"card",attrs:{"title":_vm.title,"title-style":_vm.titleStyle}},[(_vm.type === 'form')?_c('el-form',{ref:"form",staticClass:"content",attrs:{"model":_vm.model,"rules":_vm.rules,"label-width":"150rem"}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }